import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {noTimeZoneShortISODate} from '../../../common/constants/datesFormat';
import {Actions} from '../../../common/actions';
import InvoiceForm from './form';
import './editInvoice.scss';

class EditInvoice extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  getDateFormatted(inputDate) {
    let date = inputDate;
    if (typeof inputDate === 'string') {
      date = moment(inputDate);
    }
    return moment(date).format(noTimeZoneShortISODate);
  }

  getFormValuesFormatted(formValues) {
    const valuesFormatted = {...formValues};
    if (!valuesFormatted.invoiceLoadType) {
      valuesFormatted.invoiceLoadType = 'M';
    }
    valuesFormatted.invoiceDate = this.getDateFormatted(formValues.invoiceDate);
    valuesFormatted.boardingDate = this.getDateFormatted(formValues.boardingDate);
    valuesFormatted.detail = formValues.detail.map((item, index) => ({...item, 'itemNumber': index + 1}));
    return valuesFormatted;
  }

  onSubmit(typeOfSubmit, formValues) {
    const {invoice, providerId} = this.props;
    if (typeOfSubmit === 'cancel') {
      this.props.cancelInvoice(invoice, providerId);
      return;
    }

    const valuesFormatted = this.getFormValuesFormatted(formValues);
    const action = typeOfSubmit;
    this.props.createInvoice(valuesFormatted, action);
  }

  render() {
    const {invoice, providerId, push} = this.props;

    return (
      <InvoiceForm
        push={push}
        invoice={invoice}
        providerId={providerId}
        onSubmit={this.onSubmit}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {invoice} = ownProps.params;
  const {providerId} = ownProps.params;
  return {
    invoice,
    providerId,
    'push': ownProps.history.push,
  };
};

const {cancelInvoice, createInvoice, withRouter} = Actions;

export default withRouter(
  connect(mapStateToProps, {cancelInvoice, createInvoice})(EditInvoice)
);
